// Simple token estimation: ~4 characters per token (rough approximation)
// This is a simplified estimate - actual tokenization varies by model
export function estimateTokens(text) {
  if (!text) return 0;
  // Rough estimate: 1 token ≈ 4 characters for English text
  // More accurate would be ~0.75 tokens per word, but character count is simpler
  return Math.ceil(text.length / 4);
}

export function formatTokenCount(tokens) {
  if (tokens < 1000) {
    return `~${tokens} tokens`;
  }
  return `~${(tokens / 1000).toFixed(1)}k tokens`;
}

// Maximum prompt length (matches backend)
export const MAX_PROMPT_LENGTH = 10000;
